// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The markdownviewer tracker token.
 */
export const IMarkdownViewerTracker = new Token('@jupyterlab/markdownviewer:IMarkdownViewerTracker', `A widget tracker for markdown
  document viewers. Use this if you want to iterate over and interact with rendered markdown documents.`);
//# sourceMappingURL=tokens.js.map